export const BLOG_BASE_URL = 'https://finradar.brpadvice.ru';

export const BLOG_IMAGES = {
    quality: {
        src: '/assets/blog/10-minutes/kontrol-kachestva-bankovskih-vypisok.webp',
        alt: 'Контроль качества банковских выписок с проверкой периодов, наложений и проблемных файлов',
        caption: 'Контроль качества выписок помогает быстро увидеть наложения периодов, проблемные файлы и участки, требующие внимания до начала глубокой аналитики.',
    },
    operationTypes: {
        src: '/assets/blog/10-minutes/oboroty-po-tipam-operaciy.webp',
        alt: 'График оборотов по типам операций в ФинРадар',
        caption: 'Обороты по типам операций помогают быстро увидеть, из каких категорий складывается движение денег и где стоит искать нетипичную активность.',
    },
    firstCheckOperationTypes: {
        src: '/assets/blog/10-minutes/oboroty-po-tipam-operaciy.webp',
        alt: 'Обороты и структура операций по типам транзакций в ФинРадаре',
        caption: 'Обороты по типам операций помогают быстро увидеть поступления, платежи, нетто-оборот и категории транзакций, которые требуют отдельной проверки.',
    },
    counterparties: {
        src: '/assets/blog/10-minutes/analiz-oborotov-po-kontragentam.webp',
        alt: 'Анализ оборотов по контрагентам и концентрации денежных потоков',
        caption: 'Разрез по контрагентам показывает, на ком концентрируется основной поток операций и какие участники формируют существенную долю оборота.',
    },
    risks: {
        src: '/assets/blog/10-minutes/riski-po-kontragentam.webp',
        alt: 'Анализ рисков по контрагентам и организации, требующие особого внимания',
        caption: 'ФинРадар помогает быстро выделить контрагентов, требующих особого внимания: например, с признаками банкротства, массового адреса, ликвидации или других риск-факторов.',
    },
    register: {
        src: '/assets/blog/10-minutes/reestr-operaciy-po-bankovskoy-vypiske.webp',
        alt: 'Реестр операций по банковской выписке с суммами, контрагентами и назначением платежей',
        caption: 'Реестр операций позволяет быстро перейти от файла к анализу: смотреть даты, суммы, контрагентов, назначения платежей, типы транзакций и фильтровать массив.',
    },
    upload: {
        src: '/assets/blog/10-minutes/zagruzka-bankovskih-vypisok.webp',
        alt: 'Загрузка банковских выписок в ФинРадар для последующего анализа',
        caption: 'Загрузка выписок в ФинРадар: можно добавить несколько файлов в проект и начать анализ в одном рабочем контуре.',
    },
    registration: {
        src: '/assets/blog/first-check/forma-registracii-finradar.webp',
        alt: 'Форма регистрации в ФинРадаре для начала первой проверки банковских выписок',
        caption: 'Регистрация в ФинРадаре: после создания аккаунта можно сразу перейти к первой проверке банковских выписок.',
    },
    projectsDashboard: {
        src: '/assets/blog/first-check/glavnyy-ekran-proektov-finradar.webp',
        alt: 'Главный экран ФинРадара с актуальными проектами и кнопкой создания нового проекта',
        caption: 'На главном экране можно открыть существующий проект или создать новый для проверки компании, ИП, физического лица или группы компаний.',
    },
    createProject: {
        src: '/assets/blog/first-check/sozdanie-proekta-analiza.webp',
        alt: 'Создание нового проекта анализа в ФинРадаре с названием проекта и ИНН объекта анализа',
        caption: 'Создание проекта: укажите название и ИНН объекта анализа, чтобы ФинРадар корректно связал выписки с владельцем счета.',
    },
    firstCheckUpload: {
        src: '/assets/blog/10-minutes/zagruzka-bankovskih-vypisok.webp',
        alt: 'Экран загрузки банковских выписок в ФинРадар с несколькими файлами проекта',
        caption: 'Загрузите одну или несколько выписок. Новые файлы можно добавлять в проект по мере поступления.',
    },
    firstCheckQuality: {
        src: '/assets/blog/10-minutes/kontrol-kachestva-bankovskih-vypisok.webp',
        alt: 'Контроль качества загруженных банковских выписок в ФинРадаре с проверкой периодов и наложений',
        caption: 'Контроль качества помогает увидеть проблемные выписки, наложения периодов, разрывы и файлы в обработке.',
    },
    paymentsRegisterFilters: {
        src: '/assets/blog/first-check/filtry-reestra-platezhey.webp',
        alt: 'Фильтры реестра платежей в ФинРадаре для анализа банковских операций',
        caption: 'В реестре платежей и в отчетах ФинРадара можно фильтровать операции по периоду, контрагентам, выпискам, суммам, типам транзакций, назначениям платежей и другим параметрам.',
    },
    firstCheckCounterparties: {
        src: '/assets/blog/first-check/oboroty-po-kontragentam.webp',
        alt: 'Обороты по контрагентам и клиентские метрики в ФинРадаре',
        caption: 'Обороты по контрагентам показывают концентрацию денежных потоков и помогают быстро выделить ключевых участников движения денег.',
    },
    counterpartyReportWord: {
        src: '/assets/blog/first-check/otchet-po-kontragentu-word.webp',
        alt: 'Отчет по контрагенту в ФинРадаре с расчетами по периодам и типами транзакций',
        caption: 'Отчет по контрагенту помогает отдельно разобрать расчеты, типы операций, периоды и долю конкретного участника в общем денежном потоке. Его можно использовать онлайн и можно выгрузить из ФинРадара в Word.',
    },
};

export const blogPosts = [
    {
        slug: 'chto-mozhno-ponyat-po-bankovskoy-vypiske-za-10-minut',
        title: 'Что можно понять по банковской выписке за 10 минут',
        description: 'Разбираем, что арбитражный управляющий может увидеть в банковской выписке за 10 минут: подозрительные операции, ключевых контрагентов, обороты, аномалии и риски.',
        listDescription: 'Разбираем, как быстро увидеть подозрительные операции, ключевых контрагентов, обороты, аномалии и риски.',
        datePublished: '2026-04-30',
        datePublishedLabel: '30 апреля 2026',
        readingTime: '9 минут',
        category: 'Анализ выписок',
        articleSection: 'Анализ выписок',
        tags: ['Анализ выписок', 'Банкротство', 'Контрагенты', 'Подозрительные операции'],
        keywords: 'что можно понять по банковской выписке за 10 минут, анализ банковской выписки, анализ выписки должника, подозрительные операции по выписке, анализ контрагентов по выписке, как проверить выписку должника, первичный анализ банковской выписки, автоматический анализ выписки',
        heroImage: BLOG_IMAGES.upload,
        content: [
            {
                type: 'lead',
                text: 'Когда арбитражный управляющий получает банковские выписки должника, первая задача - не провести полное финансовое расследование за один подход, а быстро понять общую картину: есть ли признаки вывода активов, какие контрагенты требуют внимания, насколько поток операций похож на реальную хозяйственную деятельность и стоит ли углубляться дальше.',
            },
            {
                type: 'paragraph',
                text: 'Именно на этом этапе часто теряется много времени. Выписок много, они могут содержать тысячи строк, несколько периодов, разные форматы файлов, неоднородные назначения платежей и операции, которые сложно быстро сгруппировать вручную. Хорошая новость в том, что уже за 10 минут можно получить первичную аналитическую картину и выделить то, что требует отдельного внимания.',
            },
            { type: 'divider' },
            { type: 'h2', text: 'Зачем арбитражному управляющему быстрый анализ выписки' },
            {
                type: 'paragraph',
                text: 'В работе с должником редко есть возможность долго вчитываться в сырой файл. Обычно нужен быстрый ответ на несколько практических вопросов.',
            },
            {
                type: 'list',
                items: [
                    'есть ли в выписке подозрительные операции;',
                    'есть ли признаки транзитного движения средств;',
                    'кто формирует основной поток платежей;',
                    'есть ли контрагенты, требующие особого внимания: однодневки, аффилированные или экономически зависимые;',
                    'есть ли скачки, аномалии, дублирование, нестыковки по периодам;',
                    'сколько денег выведено через подотчетные, снятие наличных или расчеты корпоративными картами в магазинах и ресторанах;',
                    'похожа ли картина на обычную операционную деятельность или на хаотичный набор переводов.',
                ],
            },
            {
                type: 'paragraph',
                text: 'За 10 минут не обязательно делать окончательные выводы. Но вполне реально решить главное: идти в глубокую проверку или уже сейчас выделить основные зоны риска.',
            },
            { type: 'h2', text: 'Что реально можно понять по выписке за 10 минут' },
            { type: 'h3', text: '1. Видна ли общая структура движения денег' },
            {
                type: 'paragraph',
                text: 'Первое, что дает выписка, - понимание базовой структуры денежных потоков: сколько поступало, сколько списывалось, какой остаток был на начало и конец периода, насколько объем операций соответствует масштабу деятельности и есть ли резкие дисбалансы между поступлениями и списаниями.',
            },
            {
                type: 'paragraph',
                text: 'Для арбитражного управляющего это важно уже на старте: если поток операций небольшой и однородный - это одна ситуация. Если поток крупный, разнонаправленный, с множеством контрагентов и нестандартных списаний - совсем другая.',
            },
            { type: 'h3', text: '2. Есть ли проблемные периоды, разрывы или наложения' },
            {
                type: 'paragraph',
                text: 'До анализа операций нужно убедиться, что в проекте закрыты нужные периоды, нет наложения выписок, нет разрывов между интервалами, нет дублей операций и понятно, какие операции каждая отдельная выписка добавляет в общий массив проекта.',
            },
            {
                type: 'paragraph',
                text: 'Для арбитражного управляющего это не техническая мелочь, а важная часть добросовестного анализа. Если по счету есть пропуски, пересечения периодов или повторно загруженные операции, итоговые выводы по оборотам, контрагентам и подозрительным платежам могут быть искажены.',
            },
            {
                type: 'paragraph',
                text: 'В ФинРадаре можно работать не только с проектом в целом, но и с каждой выпиской отдельно: открыть конкретный файл, посмотреть его период, сверить контрольные итоги и увидеть список операций, которые он добавляет в общий массив. В ФинРадаре можно удалить задвоенные операции: целиком повторно загруженную выписку или любые задублированные периоды.',
            },
            { type: 'image', image: BLOG_IMAGES.quality },
            { type: 'h3', text: '3. Какие операции составляют основной поток' },
            {
                type: 'paragraph',
                text: 'Следующий быстрый вывод - из чего вообще состоит движение по счету. При первичном анализе важно понять, какие типы транзакций доминируют, есть ли нормальные хозяйственные платежи, как соотносятся поступления и списания, какие категории операций повторяются чаще всего и есть ли регулярные нетипичные списания.',
            },
            {
                type: 'paragraph',
                text: 'Если значительная часть движения - это однотипные переводы без явного хозяйственного смысла, постоянные перераспределения средств, займы и цессии, технические перечисления или платежи, которые не вписываются в обычную деятельность, это повод смотреть глубже.',
            },
            { type: 'image', image: BLOG_IMAGES.operationTypes },
            { type: 'h3', text: '4. Кто основные контрагенты и какова концентрация оборота' },
            {
                type: 'paragraph',
                text: 'Один из самых ценных быстрых выводов - понимание, на ком держится оборот. Уже за 10 минут можно определить основных получателей и отправителей средств, концентрацию на 1-3 контрагентах, существенные доли потока и повторяющиеся связи, которые требуют отдельной проверки.',
            },
            {
                type: 'paragraph',
                text: 'Это особенно важно в банкротных процедурах, потому что крупные и повторяющиеся контрагенты часто становятся отправной точкой для дальнейшего изучения аффилированности, экономического смысла расчетов, встречных потоков, признаков вывода активов и искусственного перераспределения денежных средств.',
            },
            { type: 'image', image: BLOG_IMAGES.counterparties },
            { type: 'h3', text: '5. Есть ли контрагенты, требующие особого внимания' },
            {
                type: 'paragraph',
                text: 'После первичной группировки становится возможен еще более полезный шаг: быстро увидеть контрагентов с повышенным риском.',
            },
            {
                type: 'list',
                items: [
                    'с признаками недостоверности данных;',
                    'с массовыми адресами;',
                    'с признаками банкротства или ликвидации;',
                    'с нетипичными встречными оборотами;',
                    'с характеристиками, которые не бьются с масштабом операций;',
                    'с иными маркерами, требующими дополнительной проверки.',
                ],
            },
            {
                type: 'paragraph',
                text: 'Для арбитражного управляющего такая выборка помогает почти сразу отделить обычный шум от тех контрагентов, вокруг которых может строиться отдельная аналитическая линия.',
            },
            { type: 'image', image: BLOG_IMAGES.risks },
            {
                type: 'cta',
                title: 'Не тратьте время на ручной разбор тысяч строк',
                text: 'Загрузите выписку в ФинРадар и быстро посмотрите обороты, контрагентов, риски и подозрительные операции.',
            },
            { type: 'h3', text: '6. Есть ли признаки подозрительных или нетипичных операций' },
            {
                type: 'paragraph',
                text: 'Быстрый анализ выписки позволяет выделить сами операции, которые выглядят нетипично: необычно крупные перечисления, нестандартные назначения платежей, повторяющиеся переводы по схожему шаблону, платежи в адрес рискованных контрагентов или операции, выбивающиеся из привычной структуры деятельности.',
            },
            {
                type: 'paragraph',
                text: 'Уже за 10 минут можно выделить подозрительные участки массива, чтобы не просматривать весь реестр вручную строка за строкой.',
            },
            {
                type: 'paragraph',
                text: 'Главный итог первых 10 минут - ответ на вопрос, похожа ли выписка на живую и понятную операционную деятельность. У реальной хозяйственной активности обычно есть логичная структура поступлений и списаний, повторяемые деловые контрагенты, понятные типы операций, отсутствие явной искусственности и соразмерность потока заявленному масштабу бизнеса.',
            },
            {
                type: 'paragraph',
                text: 'Если же выписка выглядит как хаотичный набор переводов, с неочевидными контрагентами, странными назначениями платежей и концентрацией оборота в неоднозначных точках, это само по себе уже важный первичный вывод.',
            },
            { type: 'h2', text: 'Почему вручную это часто занимает больше 10 минут' },
            {
                type: 'paragraph',
                text: 'На практике проблема не в том, что специалист не умеет анализировать банковские выписки. Проблема в том, что слишком много времени уходит на механическую работу: открыть и проверить файлы, убедиться, что периоды не пересекаются, свести операции в удобный реестр, сгруппировать контрагентов, разнести операции по типам, увидеть доли, концентрацию, аномалии и отфильтровать то, что требует внимания. Большой пласт проблем возникает из-за множества стандартов ответов банков на запросы о предоставлении выписки: Excel, PDF, Word, текстовые файлы, распечатанные документы - свести все в единую систему само по себе может оказаться задачей на неделю-полторы.',
            },
            {
                type: 'paragraph',
                text: 'Если делать это вручную, 10 минут быстро превращаются в часы и дни. А если выписок несколько постоянно растет риск что-то не увидеть, просмотреть, не оспорить и не взыскать.',
            },
            { type: 'image', image: BLOG_IMAGES.upload },
            { type: 'h2', text: 'Что помогает увидеть ФинРадар уже на первом проходе' },
            {
                type: 'list',
                items: [
                    'загруженные файлы и статус их обработки;',
                    'контроль качества выписок по периодам и счетам;',
                    'наложения, дубли и проблемные интервалы;',
                    'каждую выписку отдельно: ее период, контрольные итоги и операции, которые добавляются в общий массив;',
                    'все операции в единой системе анализа с удобным поиском, фильтрацией и быстрыми выгрузками - чтобы прикладывать к претензиям, исковым заявлениям и отчетам;',
                    'обороты по типам операций, графики и сводные итоги;',
                    'снятия наличных, выдачи подотчет, расчеты корпоративными банковскими картами;',
                    'структуру оборотов по контрагентам;',
                    'контрагентов, требующих особого внимания;',
                    'сигналы аномалий и подозрительных операций.',
                ],
            },
            { type: 'h2', text: 'Как использовать эти 10 минут на практике' },
            {
                type: 'paragraph',
                text: 'Первый 10-минутный проход по выпискам можно выстроить как короткий рабочий сценарий.',
            },
            {
                type: 'list',
                items: [
                    'Проверить качество и полноту загруженных выписок: нет ли разрывов, наложений периодов, дублей и проблемных файлов.',
                    'Оценить общие обороты: масштаб движения денег, соотношение поступлений и списаний, общую динамику.',
                    'Посмотреть структуру операций: выделить основные типы транзакций и быстро понять, из чего состоит поток.',
                    'Посмотреть ключевых контрагентов: кто формирует основную часть оборота и на ком концентрируется движение средств.',
                    'Отдельно проверить рисковых контрагентов и сузить массив до платежей, которые нужно проверять глубже.',
                ],
            },
            {
                type: 'paragraph',
                text: 'Даже такой короткий проход уже дает рабочую основу для следующего этапа: детального анализа, подготовки позиции, отбора подозрительных сделок или проверки экономического смысла операций.',
            },
            { type: 'h2', text: 'Когда 10 минут уже достаточно для первого решения' },
            {
                type: 'paragraph',
                text: 'Обычно после такого быстрого анализа можно принять одно из трех решений.',
            },
            {
                type: 'list',
                items: [
                    'Идти глубже, если уже видно рискованных контрагентов, нетипичные операции, транзитность или другие тревожные сигналы.',
                    'Дособрать данные, если проблема скорее в неполноте массива: есть разрывы, пересечения, недостающие периоды или неясные участки.',
                    'Отложить как менее приоритетный блок, если первичная картина выглядит относительно нейтральной и сейчас есть более важные направления проверки.',
                ],
            },
            {
                type: 'paragraph',
                text: 'Это и есть главная ценность быстрого анализа: не тратить ресурс вслепую, а раньше понять, где есть смысл углубляться.',
            },
            { type: 'h2', text: 'Итог' },
            {
                type: 'paragraph',
                text: 'Банковская выписка - это не просто выгрузка операций. Для арбитражного управляющего это один из самых сильных источников первичных сигналов.',
            },
            {
                type: 'paragraph',
                text: 'Уже за 10 минут по выписке можно понять масштаб и структуру движения денег, наличие проблемных периодов, ключевых контрагентов, концентрацию оборота, контрагентов, требующих особого внимания, признаки транзитности, подозрительные и нетипичные операции, а также стоит ли углубляться в проверку дальше.',
            },
            {
                type: 'paragraph',
                text: 'Если делать это вручную, значительная часть времени уйдет на технический разбор файла. Если использовать сервис, который автоматически собирает реестр операций, классифицирует поток, показывает обороты, контрагентов, риски и аномалии, то перейти к сути можно гораздо быстрее.',
            },
            {
                type: 'cta',
                title: 'Попробуйте ФинРадар бесплатно на 7 дней',
                text: 'Загрузите выписки и получите первичную картину по операциям, контрагентам, оборотам и рисковым сигналам без долгого внедрения и без сложного старта.',
            },
        ],
    },
    {
        slug: 'kak-nachat-pervuyu-proverku-v-finradar',
        title: 'Как начать первую проверку в ФинРадаре',
        description: 'Пошаговая инструкция для первой проверки в ФинРадаре: как зарегистрироваться, создать проект, загрузить банковские выписки, проверить качество файлов и перейти к анализу оборотов, контрагентов, рисков и операций.',
        listDescription: 'Пошагово: регистрация, создание проекта, загрузка выписок, контроль качества и первый анализ операций, контрагентов и отчетов.',
        datePublished: '2026-04-30',
        datePublishedLabel: '30 апреля 2026',
        readingTime: '12 минут',
        category: 'Инструкция',
        articleSection: 'Инструкция',
        tags: ['Инструкция', 'Первая проверка', 'Загрузка выписок', 'Анализ выписок'],
        keywords: 'как начать работу в ФинРадаре, первая проверка выписки, анализ банковской выписки онлайн, загрузить банковскую выписку, сервис анализа банковских выписок, автоматический анализ выписки',
        heroImage: BLOG_IMAGES.projectsDashboard,
        content: [
            {
                type: 'lead',
                text: 'ФинРадар - это онлайн сервис для анализа банковских выписок, операций, контрагентов и рисков. Чтобы начать первую проверку, не нужно проходить сложное внедрение, настраивать интеграции или ждать отдельного обучения.',
            },
            {
                type: 'paragraph',
                text: 'Достаточно зарегистрироваться, создать проект, загрузить одну или несколько выписок и дождаться обработки. После этого можно перейти к первичному анализу: проверить качество загруженных данных, посмотреть обороты, контрагентов, реестр платежей, риски и аномалии.',
            },
            {
                type: 'paragraph',
                text: 'В этой инструкции разберем первый запуск по шагам.',
            },
            { type: 'divider' },
            { type: 'h2', text: 'Что понадобится перед стартом' },
            {
                type: 'paragraph',
                text: 'Для первой проверки лучше заранее подготовить данные, которые понадобятся для создания проекта и загрузки выписок.',
            },
            {
                type: 'list',
                items: [
                    'ИНН компании, ИП или физического лица, по которому проводится анализ;',
                    'банковские выписки в Excel, TXT / 1C Client-Bank, PDF или другом доступном формате;',
                    'период анализа, который нужно проверить;',
                    'несколько файлов, если выписки получены из разных банков, по разным счетам или за разные периоды.',
                ],
            },
            {
                type: 'paragraph',
                text: 'Лучше всего для быстрой обработки подходят XLS / XLSX и TXT / 1C Client-Bank. Также ФинРадар работает с текстовыми PDF и другими форматами банковских выписок. Некоторые файлы обрабатываются за несколько минут, а сложные или нестандартные форматы могут потребовать больше времени.',
            },
            {
                type: 'paragraph',
                text: 'Сканированные выписки также можно обрабатывать, но это более трудоемкий сценарий: распознавание сканов сложнее, дольше и дороже, чем работа с текстовыми или табличными файлами.',
            },
            { type: 'h2', text: 'Шаг 1. Зарегистрируйтесь в ФинРадаре' },
            {
                type: 'paragraph',
                text: 'Первый шаг - регистрация. В форме нужно указать email, имя и телефон, а также принять условия оферты и политики обработки персональных данных.',
            },
            {
                type: 'paragraph',
                text: 'После регистрации можно войти в сервис и начать первую проверку.',
            },
            { type: 'signup' },
            { type: 'h2', text: 'Шаг 2. Откройте рабочий экран и создайте новый проект' },
            {
                type: 'paragraph',
                text: 'После входа пользователь попадает на экран актуальных проектов. Здесь можно продолжить работу с уже созданными проверками или начать новый проект.',
            },
            {
                type: 'paragraph',
                text: 'Для первой проверки нажмите «Новый проект». Проект - это рабочее пространство, в котором собираются выписки, счета, операции, контрагенты и аналитика по одной компании, ИП, физическому лицу или группе связанных лиц.',
            },
            { type: 'image', image: BLOG_IMAGES.projectsDashboard },
            { type: 'h2', text: 'Шаг 3. Укажите название проекта и ИНН объекта анализа' },
            {
                type: 'paragraph',
                text: 'При создании проекта нужно указать название проекта и ИНН объекта анализа.',
            },
            {
                type: 'paragraph',
                text: 'ИНН важен для корректной идентификации владельца счета и дальнейшей аналитики. Если создать проект без ИНН, система может неверно определить владельца счета или некорректно отразить реквизиты, особенно если банк указывает данные в нестандартном формате.',
            },
            {
                type: 'list',
                items: [
                    'стандартный анализ - для одной компании, ИП или физического лица;',
                    'анализ группы - если нужно собрать выписки по нескольким связанным лицам или компаниям в одном проекте.',
                ],
            },
            {
                type: 'paragraph',
                text: 'Для первой проверки обычно достаточно стандартного анализа.',
            },
            { type: 'image', image: BLOG_IMAGES.createProject },
            { type: 'h2', text: 'Шаг 4. Загрузите банковские выписки' },
            {
                type: 'paragraph',
                text: 'После создания проекта можно добавить выписки. ФинРадар позволяет загрузить один или несколько файлов. Это удобно, если нужно проанализировать несколько банковских счетов, выписки за разные периоды, файлы из разных банков или отдельные выписки в Excel, TXT, PDF или другом формате.',
            },
            {
                type: 'paragraph',
                text: 'Выписки можно добавлять постепенно. Новые файлы будут дополнять общий массив проекта.',
            },
            {
                type: 'paragraph',
                text: 'Перед добавлением файлов с выписками, надо выбрать владельца счета. Если в выписке есть ИНН владельца счета, ФинРадар может проверить и исправить определить владельца автоматически.',
            },
            { type: 'image', image: BLOG_IMAGES.firstCheckUpload },
            { type: 'h2', text: 'Шаг 5. Дождитесь обработки файлов' },
            {
                type: 'paragraph',
                text: 'После загрузки файлы проходят обработку. Статус каждого файла отображается отдельно: можно видеть, какие выписки уже сохранены, какие находятся в очереди, какие отправляются на сервер и какие требуют внимания.',
            },
            {
                type: 'paragraph',
                text: 'Обработка зависит от формата файла, размера выписки и сложности структуры. Простые Excel или TXT-файлы обычно обрабатываются быстрее. Более сложные PDF, нестандартные форматы или сканы могут занимать больше времени.',
            },
            {
                type: 'paragraph',
                text: 'После завершения обработки можно перейти к работе с проектом.',
            },
            { type: 'h2', text: 'Шаг 6. Проверьте качество загруженных выписок' },
            {
                type: 'paragraph',
                text: 'Перед тем как анализировать обороты и риски, важно убедиться, что массив данных собран корректно. В ФинРадаре вы можете отслеживать:',
            },
            {
                type: 'list',
                items: [
                    'сколько выписок загружено;',
                    'сколько счетов обнаружено;',
                    'есть ли проблемные выписки;',
                    'какие файлы еще в обработке;',
                    'есть ли счета с разрывами;',
                    'есть ли счета с наложениями периодов;',
                    'были ли данные изменены вручную.',
                ],
            },
            {
                type: 'paragraph',
                text: 'Это особенно важно, если в проект загружено несколько выписок по одному счету. Например, один файл может закрывать период с января по декабрь, а второй - частично пересекаться с этим же периодом. В таком случае может возникнуть дублирование операций.',
            },
            {
                type: 'paragraph',
                text: 'ФинРадар помогает увидеть такие ситуации до того, как пользователь начнет делать выводы по оборотам и контрагентам.',
            },
            { type: 'image', image: BLOG_IMAGES.firstCheckQuality },
            { type: 'h2', text: 'Шаг 7. Разберите проблемные выписки, если они есть' },
            {
                type: 'paragraph',
                text: 'Если ФинРадар показывает наложение периодов, дублирование операций или файл, требующий внимания, это не значит, что проект нужно создавать заново. В ФинРадаре можно удалять лишние выписки целиком, удалять отдельные периоды внутри любой выписки, изменять и уточнять промежуточные итоги и подытоги. ФинРадар позволяет:',
            },
            {
                type: 'list',
                items: [
                    'открыть конкретную выписку;',
                    'посмотреть ее период;',
                    'сверить контрольные итоги и внести отсутствующие данные;',
                    'просмотреть операции, которые добавляются к общему массиву проекта;',
                    'удалить операции за пересекающийся период;',
                    'уточнить данные, если файл обработан не так, как ожидалось.',
                ],
            },
            {
                type: 'paragraph',
                text: 'Это важно для корректной аналитики. Если не убрать дубли или наложения, обороты, списания, поступления и показатели по контрагентам могут быть завышены.',
            },
            {
                type: 'paragraph',
                text: 'Для арбитражных управляющих, кредитных аналитиков и брокеров это особенно критично: решение должно опираться на корректный массив операций, а не на случайно задублированные данные.',
            },
            { type: 'h2', text: 'Шаг 8. Посмотрите обороты и структуру операций' },
            {
                type: 'paragraph',
                text: 'Следующий шаг - анализ оборотов. ФинРадар показывает движение денег по типам операций, периодам и направлениям. Типы операций ФинРадар размечает автоматически на основе содержимого платежа и данных о контрагенте. Некоторые типы при проверке работают как красная тряпка. Цессии, аномально высокие выдачи под отчет, частые снятия наличных, расчеты банковскими бизнес-картами в дорогих магазинах и ресторанах - очевидные и тем не менее частые способы выводить деньги из бизнеса.',
            },
            {
                type: 'list',
                items: [
                    'сколько было поступлений;',
                    'сколько было платежей;',
                    'какой получился нетто-оборот;',
                    'какие типы операций формируют основной поток;',
                    'есть ли подотчетные выдачи, цессии, займы, расчеты бизнес-картами и насколько они аномальны;',
                    'как менялась активность по месяцам, кварталам или годам;',
                    'в любые данные можно провалиться - посмотреть какие конкретно платежи формируют ту или иную сумму.',
                ],
            },
            {
                type: 'paragraph',
                text: 'Это помогает перейти от сырой выписки к понятной структуре финансового движения.',
            },
            {
                type: 'paragraph',
                text: 'Например, для арбитражного управляющего это способ быстро увидеть периоды высокой активности, нетипичные всплески или категории операций, которые требуют отдельной проверки. Для кредитного брокера или МФО - способ быстро оценить характер денежного потока клиента.',
            },
            { type: 'image', image: BLOG_IMAGES.firstCheckOperationTypes },
            { type: 'h2', text: 'Шаг 9. Изучите контрагентов и концентрацию оборотов' },
            {
                type: 'paragraph',
                text: 'Очень полезный раздел первой проверки - обороты по контрагентам. С помощью ФинРадара можно быстро определить:',
            },
            {
                type: 'list',
                items: [
                    'основных контрагентов;',
                    'суммы поступлений и платежей;',
                    'долю контрагента в общем потоке;',
                    'количество операций;',
                    'структуру концентрации и зависимости от контрагентов;',
                    'новых и потерянных контрагентов;',
                    'детализацию по отдельному контрагенту.',
                ],
            },
            {
                type: 'paragraph',
                text: 'Это помогает быстро понять, на ком держится движение денег.',
            },
            {
                type: 'paragraph',
                text: 'Если значительная часть поступлений или списаний сосредоточена вокруг 1-3 контрагентов, это важный сигнал. Для арбитражного управляющего такие контрагенты могут стать первыми кандидатами для более глубокой проверки. Для кредитного анализа это может говорить о зависимости бизнеса от ограниченного круга клиентов или поставщиков.',
            },
            {
                type: 'paragraph',
                text: 'В расчеты с любым контрагентом можно развернуть до конкретных операций, посмотреть, что именно указано в назначениях платежей, носят ли платежи регулярный или хаотичный характер, какие счета есть у контрагента. ФинРадар позволяет одной кнопкой выгрузить операции с указанием реквизитов и выписок-источников в Excel-файл, чтобы готовить юридические документы.',
            },
            { type: 'image', image: BLOG_IMAGES.firstCheckCounterparties },
            { type: 'h2', text: 'Шаг 10. Перейдите к реестру платежей' },
            {
                type: 'paragraph',
                text: 'В ФинРадаре можно работать как со стандартными отчетами: по типам операций, по контрагентам, по рискам, - так и с реестром платежей. Реестр платежей - это рабочая таблица со всеми операциями по проекту.',
            },
            {
                type: 'list',
                items: [
                    'дату операции;',
                    'сумму;',
                    'контрагента;',
                    'назначение платежа;',
                    'тип транзакции;',
                    'тип контрагента;',
                    'расчетный счет контрагента, если он определен;',
                    'операции из конкретных выписок или всего проекта.',
                ],
            },
            {
                type: 'paragraph',
                text: 'Реестр полезен не только для просмотра, но и для уточнения данных. В нем можно посмотреть дополнительные реквизиты контрагента, уточнить тип операции и даже исправить сведения о контрагентах по операциям. В реестре платежей, как и во всех отчетах ФинРадара можно фильтровать платежи по периоду, контрагенту, выписке, сумме, направлению операции, типу транзакции или назначению платежа.',
            },
            { type: 'image', image: BLOG_IMAGES.paymentsRegisterFilters },
            { type: 'h2', text: 'Шаг 11. Откройте отчет по конкретному контрагенту и выгрузите его в Word' },
            {
                type: 'paragraph',
                text: 'Если отдельный контрагент выглядит значимым или рискованным, можно открыть отчет по нему. В отчете расчеты с контрагентом показаны с разных сторон:',
            },
            {
                type: 'list',
                items: [
                    'расчеты по периодам;',
                    'поступления от контрагента;',
                    'платежи контрагенту;',
                    'типы транзакций;',
                    'долю в общем потоке;',
                    'динамику операций;',
                    'связанные варианты наименований из выписок;',
                    'данные из ЕГРЮЛ.',
                ],
            },
            {
                type: 'paragraph',
                text: 'Такой отчет помогает быстро перейти от общей картины к конкретной связи: кто этот контрагент, сколько денег прошло через него, в какие периоды и по каким типам операций.',
            },
            {
                type: 'paragraph',
                text: 'Отчет по контрагенту можно выгрузить в Word одной кнопкой. При необходимости можно настроить, какие данные включать в отчет и как их сгруппировать для более удобного представления выявленных операций.',
            },
            { type: 'image', image: BLOG_IMAGES.counterpartyReportWord },
            { type: 'h2', text: 'Что считается первым результатом проверки' },
            {
                type: 'paragraph',
                text: 'Первая проверка считается выполненной, когда проект создан, выписки загружены и обработаны, операции сохранены в общий массив, контроль качества не показывает критичных проблем или пользователь понимает, какие файлы требуют внимания. Уже сразу после автоматической обработки выписок в ФинРадаре открывается множество возможностей:',
            },
            {
                type: 'list',
                items: [
                    'доступны обороты по типам операций;',
                    'доступны контрагенты и структура оборотов;',
                    'можно проваливаться в конкретные операции, которые формируют интересующие расчеты - например, что за займы, цессии или платежи на ООО Одуванчик с массовым директором по данным ЕГРЮЛ;',
                    'можно работать с реестром платежей;',
                    'можно фильтровать операции;',
                    'можно переходить к рискам, аномалиям и отчетам по контрагентам.',
                ],
            },
            {
                type: 'paragraph',
                text: 'Первый результат - это не обязательно финальный аналитический отчет. Это рабочая картина, которая позволяет понять, что есть в выписках, какие данные требуют корректировки, где сосредоточены основные обороты, какие контрагенты важны и какие операции и периоды стоит смотреть глубже.',
            },
            {
                type: 'paragraph',
                text: 'Дальнейшая работа может включать получение дополнительных сведений, например, книг покупок и продаж - которые можно добавить в проект в ФинРадаре; проведение сверок с контрагентами; претензионную и исковую работу.',
            },
            { type: 'h2', text: 'Что делать, если файл обработался не сразу' },
            {
                type: 'paragraph',
                text: 'Если файл не обработался мгновенно, это не всегда ошибка. Скорость зависит от формата и сложности выписки. Excel и TXT / 1C Client-Bank обычно обрабатываются быстрее. PDF может потребовать больше времени, особенно если структура нестандартная. Сканированные документы требуют распознавания и относятся к более сложным сценариям.',
            },
            {
                type: 'paragraph',
                text: 'Если файл крупный, нестандартный или требует дополнительной обработки, лучше дождаться статуса в проекте или обратиться в поддержку.',
            },
            { type: 'h2', text: 'Что делать, если обнаружены наложения периодов' },
            {
                type: 'paragraph',
                text: 'Если ФинРадар показывает наложение периодов, нужно проверить, какие выписки пересекаются.',
            },
            {
                type: 'list',
                items: [
                    'один и тот же период загружен дважды;',
                    'банк сформировал выписку с пересекающимися датами;',
                    'пользователь загрузил годовую выписку и отдельно файл за часть того же года;',
                    'по счету есть несколько файлов с частичным дублированием.',
                ],
            },
            {
                type: 'paragraph',
                text: 'В этом случае можно открыть отдельную выписку, посмотреть операции, которые она добавляет в общий массив, и удалить лишние операции за период наложения. Главная задача - сохранить корректную базу для дальнейшего анализа.',
            },
            { type: 'h2', text: 'Кому полезна первая проверка в ФинРадаре' },
            {
                type: 'paragraph',
                text: 'ФинРадар можно использовать в разных сценариях.',
            },
            {
                type: 'list',
                items: [
                    'Арбитражным управляющим - чтобы быстро собрать массив выписок должника, проверить качество данных, выделить ключевых контрагентов, подозрительные операции и периоды для дальнейшего анализа.',
                    'Кредитным брокерам - чтобы заранее оценить клиента, увидеть слабые места в выписке и понять, стоит ли подавать кейс кредитору.',
                    'МФО и кредитным аналитикам - чтобы провести первичный анализ заемщика по движению денег, структуре поступлений, концентрации контрагентов и характеру операций.',
                    'Финансовым аналитикам и консультантам - чтобы быстрее перейти от банковских файлов к понятной структуре операций и отчетам.',
                ],
            },
            {
                type: 'cta',
                title: 'Попробуйте ФинРадар бесплатно 7 дней',
                text: 'Начать можно с одной выписки. Создайте проект, загрузите файл и посмотрите, какие данные ФинРадар покажет после первой обработки: обороты, операции, контрагентов, фильтры, риски и качество загруженных выписок.',
            },
            {
                type: 'faq',
                items: [
                    {
                        question: 'Можно ли начать анализ с одной выписки?',
                        answer: 'Да. Для первой проверки достаточно загрузить одну банковскую выписку. Позже можно добавить новые файлы в тот же проект.',
                    },
                    {
                        question: 'Какие форматы выписок поддерживает ФинРадар?',
                        answer: 'Лучше всего подходят XLS / XLSX и TXT / 1C Client-Bank. Также ФинРадар работает с текстовыми PDF и другими форматами банковских выписок. Сканированные документы возможны, но требуют более сложной обработки.',
                    },
                    {
                        question: 'Нужно ли вручную объединять выписки перед загрузкой?',
                        answer: 'Нет. Можно загрузить несколько файлов в один проект. ФинРадар помогает собрать общий массив операций и проверить качество данных по счетам и периодам.',
                    },
                    {
                        question: 'Что делать, если периоды выписок пересекаются?',
                        answer: 'Нужно открыть проблемную выписку и проверить, какие операции она добавляет в проект. При необходимости лишние операции за пересекающийся период можно удалить.',
                    },
                    {
                        question: 'Что пользователь увидит после первой проверки?',
                        answer: 'После обработки доступны операции, обороты, контрагенты, фильтры, качество загруженных выписок, а также разделы для анализа рисков и детализации по контрагентам.',
                    },
                    {
                        question: 'Есть ли бесплатный период?',
                        answer: 'Да. ФинРадар можно попробовать бесплатно в течение 7 дней.',
                    },
                ],
            },
        ],
    },
    {
        "slug": "7-anomaliy-v-bankovskoy-vypiske-yuridicheskogo-lica",
        "title": "7 аномалий в банковской выписке юридического лица, которые стоит проверить в первую очередь",
        "description": "Разбираем 7 аномалий в банковской выписке юридического лица при банкротстве: платежи техническим компаниям, резкий рост зарплат, погашение займов физлицам, подотчетные суммы, личные расходы, встречные расчеты и концентрация платежей на рискованных контрагентах.",
        "listDescription": "Практический разбор сигналов в выписке юридического лица, которые стоит проверить первыми при анализе должника в банкротстве.",
        "datePublished": "2026-05-04",
        "dateModified": "2026-05-04",
        "datePublishedLabel": "4 мая 2026",
        "readingTime": "13 минут",
        "category": "Банкротство",
        "articleSection": "Анализ выписок",
        "tags": [
            "Анализ выписок",
            "Банкротство",
            "Юридические лица",
            "Подозрительные операции",
            "Контрагенты"
        ],
        "keywords": "аномалии в банковской выписке юридического лица, анализ выписки юридического лица, банковская выписка должника юридического лица, подозрительные операции в выписке юрлица, анализ выписки должника при банкротстве, вывод активов юридического лица, оспаривание сделок юридического лица, предбанкротный период юридического лица, платежи техническим компаниям, анализ контрагентов в банкротстве",
        "heroImage": {
            "src": "/assets/blog/10-minutes/riski-po-kontragentam.webp",
            "alt": "7 аномалий в банковской выписке юридического лица для проверки при банкротстве",
            "caption": "Анализ выписки юридического лица помогает выделить контрагентов, операции и периоды, которые требуют первоочередной проверки."
        },
        "content": [
            {
                "type": "lead",
                "text": "Банковские выписки должника-организации хорошо показывают аномальные операции. Хотя сама по себе не каждая аномалия является сделкой под оспаривание, банковские выписки показывают, на что обратить особое внимание: контрагенты, через которых оптимизировали налоги; юридически не связанные лица, с которыми существует экономическая взаимозависимость; сделки с предпочтением, – эти и другие операции частые находки в банковских выписках предприятия-банкрота."
            },
            {
                "type": "paragraph",
                "text": "По движению денег можно увидеть платежи рискованным контрагентам, резкий рост выплат связанным лицам, нетипичные расходы, регулярные подотчетные суммы, встречные расчеты и другие сигналы, которые могут указывать на вывод активов или искажение реальной экономической картины бизнеса."
            },
            {
                "type": "paragraph",
                "text": "В этой статье речь идет о банковских выписках юридических лиц. Выписки физических лиц в банкротстве имеют другую структуру рисков и требуют отдельного подхода: там важнее личные расходы, переводы родственникам, снятие наличных, сделки с имуществом и движение средств по личным счетам."
            },
            {
                "type": "paragraph",
                "text": "Важно: сама по себе аномалия в выписке не означает, что сделка недействительна или незаконна. Это сигнал для проверки. Нужно смотреть период платежа, финансовое состояние должника, экономический смысл операции, документы, связь сторон и добросовестность получателя."
            },
            {
                "type": "h2",
                "text": "1. Платежи контрагентам с недостоверными сведениями в ЕГРЮЛ"
            },
            {
                "type": "paragraph",
                "text": "Один из первых сигналов – крупные или регулярные платежи организациям, по которым в ЕГРЮЛ есть записи о недостоверности сведений."
            },
            {
                "type": "list",
                "items": [
                    "недостоверные сведения о руководителе;",
                    "недостоверные сведения об участниках;",
                    "массовый адрес;",
                    "признаки ликвидации;",
                    "сведения о банкротстве;",
                    "отсутствие понятной деловой активности;",
                    "несоответствие масштаба контрагента объему полученных платежей."
                ]
            },
            {
                "type": "paragraph",
                "text": "Если должник перечислял значительные суммы такой организации, это может указывать на расчеты с технической компанией. В отдельных случаях такие контрагенты могут использоваться как компании-однодневки, но в аналитике лучше говорить аккуратнее: контрагент требует дополнительной проверки."
            },
            {
                "type": "h3",
                "text": "Почему это важно"
            },
            {
                "type": "paragraph",
                "text": "Для оспаривания сделок и анализа вывода активов важно понять, был ли у контрагента реальный экономический смысл в операции: мог ли он поставить товар или оказать услугу, были ли у него сотрудники, ресурсы, склад, техника и деловая история, соответствует ли его профиль назначению платежа, не связан ли он с должником или контролирующими лицами."
            },
            {
                "type": "h3",
                "text": "Пример"
            },
            {
                "type": "paragraph",
                "text": "Должник перечисляет 18 млн рублей компании за консультационные услуги. В выписке платеж выглядит формально нейтрально. Но при проверке контрагента видно: недостоверные сведения о руководителе, массовый адрес, численность персонала – 1 человек, выручка по отчетности несопоставима с масштабом операций."
            },
            {
                "type": "paragraph",
                "text": "Это не доказывает вывод активов автоматически, но делает операцию приоритетной для проверки."
            },
            {
                "type": "h3",
                "text": "Как помогает ФинРадар"
            },
            {
                "type": "paragraph",
                "text": "В ФинРадаре можно увидеть не только платежи, но и риск-маркеры по контрагентам. Сервис агрегирует данные по контрагентам и помогает быстро выделить организации, которые требуют особого внимания: с недостоверными сведениями, признаками банкротства, ликвидации, массовым адресом и другими факторами риска."
            },
            {
                "type": "image",
                "image": {
                    "src": "/assets/blog/10-minutes/riski-po-kontragentam.webp",
                    "alt": "Анализ рисков по контрагентам в ФинРадаре с маркерами недостоверности, банкротства и ликвидации",
                    "caption": "ФинРадар помогает быстро выделить контрагентов с риск-маркерами и посмотреть, какие суммы проходили через них в анализируемом периоде."
                }
            },
            {
                "type": "h2",
                "text": "2. Концентрация исходящих платежей на нескольких слабых контрагентах"
            },
            {
                "type": "paragraph",
                "text": "Вторая важная аномалия – когда значительная часть исходящих платежей сосредоточена на нескольких контрагентах, которые сами выглядят слабыми или непрозрачными."
            },
            {
                "type": "list",
                "items": [
                    "у контрагентов низкая численность персонала;",
                    "нет заметной деловой репутации;",
                    "нет понятной специализации под объем операций;",
                    "выручка сопоставима с суммами, которые им перечисляет анализируемое общество;",
                    "есть риск-маркеры в ЕГРЮЛ;",
                    "профиль деятельности плохо соответствует назначению платежей."
                ]
            },
            {
                "type": "h3",
                "text": "Почему это важно"
            },
            {
                "type": "paragraph",
                "text": "Концентрация платежей сама по себе не является нарушением. У компании может быть один крупный поставщик или подрядчик. Но если этот поставщик не выглядит способным исполнить обязательства на десятки миллионов рублей, это требует отдельной проверки."
            },
            {
                "type": "paragraph",
                "text": "Для арбитражного управляющего здесь важны вопросы: почему именно эти контрагенты получали основной поток денег, были ли реальные поставки, работы или услуги, соответствуют ли платежи рыночным условиям, не использовался ли контрагент как промежуточное звено и не выводилась ли через него маржа или ликвидность должника."
            },
            {
                "type": "h3",
                "text": "Пример"
            },
            {
                "type": "paragraph",
                "text": "За год должник перечислил 72 млн рублей трем компаниям. У каждой – минимальная численность персонала, нет заметной публичной деловой истории, а годовая выручка одной из компаний почти полностью совпадает с суммой, полученной от должника."
            },
            {
                "type": "paragraph",
                "text": "Такая картина может означать, что должник был ключевым или почти единственным источником оборота для контрагента. Это не делает сделки недействительными автоматически, но требует проверки экономического смысла и реальности исполнения."
            },
            {
                "type": "h3",
                "text": "Как помогает ФинРадар"
            },
            {
                "type": "paragraph",
                "text": "В разделе оборотов по контрагентам можно увидеть, кому перечислялись основные суммы, какую долю в исходящем потоке занимает каждый контрагент, сколько операций прошло по контрагенту, как соотносятся платежи, поступления, оборот и нетто-позиция, а также какие контрагенты требуют дополнительной проверки по внешним данным."
            },
            {
                "type": "paragraph",
                "text": "В ФинРадаре можно одним кликом перейти от взаиморасчетов с контрагентом к его проверке по данным ЕГРЮЛ с учетом финансовой отчетности, налогов, численности персонала и других сведений."
            },
            {
                "type": "image",
                "image": {
                    "src": '/assets/blog/first-check/oboroty-po-kontragentam.webp',
                    "alt": "Обороты по контрагентам в банковской выписке должника и концентрация исходящих платежей",
                    "caption": "Обороты по контрагентам показывают концентрацию исходящих платежей и долю каждого участника в денежном потоке."
                }
            },
            {
                "type": "h2",
                "text": "3. Активные встречные расчеты с одним контрагентом"
            },
            {
                "type": "paragraph",
                "text": "Иногда аномалия видна не в отдельном платеже, а в характере расчетов с одним и тем же контрагентом. Например, должник регулярно перечисляет деньги контрагенту за сырье, материалы или услуги, а затем получает от него поступления за готовую продукцию, товары или работы. Другой случай, когда в одну сторону идут деньги за товары, а обратно - в виде займов."
            },
            {
                "type": "paragraph",
                "text": "Формально такие операции могут выглядеть как обычные хозяйственные отношения: одна сторона поставляет сырье, другая покупает продукцию. Но для арбитражного управляющего это важный сигнал: если контрагент одновременно является и поставщиком, и покупателем, нужно проверить экономический смысл такой модели и фактическое распределение выгоды."
            },
            {
                "type": "h3",
                "text": "Почему это важно"
            },
            {
                "type": "paragraph",
                "text": "Встречные расчеты с одним контрагентом могут быть нормальной частью бизнеса. Но они требуют внимания, если через такого контрагента проходит существенная доля оборота, операции повторяются регулярно, а маржа или экономический результат выглядят неочевидно."
            },
            {
                "type": "list",
                "items": [
                    "почему один и тот же контрагент одновременно продает сырье и покупает продукцию;",
                    "соответствуют ли цены рыночным условиям;",
                    "где остается экономическая выгода;",
                    "не формируется ли убыток у должника при прибыли у другой стороны;",
                    "есть ли связь контрагента с должником, руководством или участниками;",
                    "подтверждены ли поставки, отгрузки и встречное исполнение;",
                    "не используется ли контрагент как промежуточное звено для перераспределения прибыли."
                ]
            },
            {
                "type": "h3",
                "text": "Пример"
            },
            {
                "type": "paragraph",
                "text": "Должник регулярно платит одному и тому же контрагенту за ткани и фурнитуру. В то же время от этого же контрагента поступают деньги за готовую одежду. В выписке это выглядит как встречный поток: должник то платит контрагенту, то получает от него поступления."
            },
            {
                "type": "paragraph",
                "text": "На первом уровне это может быть обычная хозяйственная модель. Но если по итогам периода должник несет основную производственную нагрузку, оплачивает сырье, персонал и операционные расходы, а прибыль фактически остается у контрагента, такая структура требует проверки."
            },
            {
                "type": "paragraph",
                "text": "Управляющему стоит сопоставить платежи за сырье, поступления за продукцию, договоры, товарные документы, цены, маржинальность и связь сторон. Особенно важно понять, не приводила ли такая модель к тому, что обязательства и расходы оставались на должнике, а экономическая выгода концентрировалась у другого лица."
            },
            {
                "type": "h3",
                "text": "Как помогает ФинРадар"
            },
            {
                "type": "paragraph",
                "text": "ФинРадар помогает быстро увидеть встречные обороты с конкретным контрагентом: сколько должник перечислил ему, сколько получил обратно, в какие периоды проходили расчеты и какие типы операций использовались."
            },
            {
                "type": "paragraph",
                "text": "В отчете по контрагенту можно отдельно посмотреть поступления, платежи, нетто-позицию, динамику по периодам, назначения платежей и варианты наименований из выписок. Это делает кейс удобным для первичной проверки: управляющий сразу видит, что контрагент работает с должником в обе стороны, а затем может перейти к документам и экономическому смыслу операций."
            },
            {
                "type": "image",
                "image": {
                    "src": "/assets/blog/7-anomaliy/otchet-po-kontragentu-vstrechnye-raschety.webp",
                    "alt": "Отчет по контрагенту в ФинРадаре с встречными расчетами, поступлениями и платежами",
                    "caption": "Отчет по контрагенту помогает увидеть встречные обороты: сколько должник перечислил контрагенту, сколько получил от него обратно и как менялась нетто-позиция по периодам."
                }
            },
            {
                "type": "h2",
                "text": "4. Погашение займов физическим лицам незадолго до банкротства"
            },
            {
                "type": "paragraph",
                "text": "Отдельного внимания заслуживают платежи физическим лицам с назначением вроде: возврат займа, погашение займа, возврат денежных средств по договору займа или расчеты по договору займа."
            },
            {
                "type": "paragraph",
                "text": "Особенно если такие платежи проходят за месяц или несколько месяцев до подачи заявления о банкротстве."
            },
            {
                "type": "h3",
                "text": "Почему это важно"
            },
            {
                "type": "paragraph",
                "text": "Погашение займа само по себе законно. Но в предбанкротный период такие операции требуют проверки, особенно если получатель связан с должником, руководителем, участниками или менеджментом."
            },
            {
                "type": "list",
                "items": [
                    "когда возникло обязательство по займу;",
                    "действительно ли деньги ранее поступали должнику;",
                    "кто является получателем;",
                    "есть ли связь с контролирующими лицами;",
                    "было ли у должника уже ухудшение финансового состояния;",
                    "не получил ли один кредитор преимущество перед другими."
                ]
            },
            {
                "type": "h3",
                "text": "Пример"
            },
            {
                "type": "paragraph",
                "text": "За месяц до подачи заявления о банкротстве должник перечисляет физическому лицу 9,5 млн рублей как возврат займа. При этом на тот же период уже есть просроченные обязательства перед поставщиками, налоговой или банком."
            },
            {
                "type": "paragraph",
                "text": "Такая операция может быть значимой для анализа предпочтительного удовлетворения требований, вывода ликвидности или расчетов со связанным лицом."
            },
            {
                "type": "h3",
                "text": "Как помогает ФинРадар"
            },
            {
                "type": "paragraph",
                "text": "Самый быстрый способ найти расчеты по займам в период перед банкротством - развернуть операции по такому типу расчетов за нужный период."
            },
            {
                "type": "paragraph",
                "text": "В ФинРадаре можно также использовать фильтры по типу операции, фильтр по физическим лицам, фильтр по периоду перед банкротством, поиск по назначению платежа и реестр платежей с детализацией суммы, даты, контрагента и назначения."
            },
            {
                "type": "image",
                "image": {
                    "src": "/assets/blog/first-check/filtry-reestra-platezhey.webp",
                    "alt": "Фильтры реестра платежей для поиска займов, подотчетных сумм и подозрительных операций",
                    "caption": "Фильтры помогают быстро найти займы, подотчетные суммы и другие операции по типу, периоду и назначению."
                }
            },
            {
                "type": "h2",
                "text": "5. Резкий рост выплат заработной платы руководителю и топ-менеджерам"
            },
            {
                "type": "paragraph",
                "text": "Зарплата – обычная хозяйственная операция. Но резкий рост выплат в предбанкротный период может быть важной аномалией."
            },
            {
                "type": "list",
                "items": [
                    "выплаты увеличиваются незадолго до банкротства;",
                    "получатели – учредитель-директор или топ-менеджеры;",
                    "суммы достигают миллионов рублей в месяц;",
                    "нет сопоставимого роста налогов и страховых взносов;",
                    "выплаты происходят на фоне ухудшения финансового состояния компании."
                ]
            },
            {
                "type": "h3",
                "text": "Почему это важно"
            },
            {
                "type": "paragraph",
                "text": "Если компания за несколько месяцев до банкротства резко увеличивает выплаты связанным сотрудникам, это может указывать на вывод ликвидности под видом зарплаты, премий или компенсаций."
            },
            {
                "type": "paragraph",
                "text": "Нужно проверять трудовые договоры, приказы о премировании, экономическое обоснование выплат, должности и функции получателей, НДФЛ и страховые взносы за эти периоды, финансовое состояние компании на дату выплат и сопоставимость выплат с обычным уровнем дохода."
            },
            {
                "type": "h3",
                "text": "Пример 1"
            },
            {
                "type": "paragraph",
                "text": "За 3 месяца до банкротства зарплатные выплаты выросли с 400 тыс. до 4,8 млн рублей в месяц. Основные получатели – директор, учредитель и несколько топ-менеджеров."
            },
            {
                "type": "paragraph",
                "text": "Сам рост выплат не доказывает нарушение, но требует проверки: почему выплаты выросли именно в этот период, были ли основания для премий, удерживался ли НДФЛ, начислялись ли страховые взносы, соответствовали ли выплаты реальной работе."
            },
            {
                "type": "h3",
                "text": "Пример 2"
            },
            {
                "type": "paragraph",
                "text": "За несколько месяцев до банкротства должник начал перечислять почти все свободные средства нескольким сотрудникам под видом заработной платы. При этом НДФЛ и страховые взносы за те же периоды оставались примерно на прежнем уровне."
            },
            {
                "type": "paragraph",
                "text": "В отдельные месяцы выплаты директору подскакивали до 6–7 млн рублей, в другие – достигали 2–3 млн рублей. Такая динамика требует отдельного анализа, потому что может указывать на несоответствие между фактическими выплатами и налоговой частью зарплатного контура."
            },
            {
                "type": "h3",
                "text": "Как помогает ФинРадар"
            },
            {
                "type": "paragraph",
                "text": "ФинРадар помогает увидеть динамику зарплатных выплат, рост выплат по месяцам, операции по конкретным получателям, типы операций, связанные с зарплатой и аналогичными платежами, периоды резкого роста и платежи в пользу руководителей или сотрудников, если они выделены в реестре."
            },
            {
                "type": "image",
                "image": {
                    "src": "/assets/blog/7-anomaliy/zarplatnye-anomalii.webp",
                    "alt": "Обороты по типам операций в ФинРадаре для поиска резкого роста зарплат и других выплат",
                    "caption": "Динамика по типам операций помогает увидеть резкий рост отдельных категорий платежей, например выплат физическим лицам или зарплатных перечислений."
                }
            },
            {
                "type": "h2",
                "text": "6. Регулярные выдачи подотчетных средств крупными суммами"
            },
            {
                "type": "paragraph",
                "text": "Подотчетные средства – нормальный инструмент хозяйственной деятельности. Но если выплаты под отчет становятся регулярными, крупными и плохо объяснимыми, это отдельный риск."
            },
            {
                "type": "list",
                "items": [
                    "выдачи по 2–3 млн рублей каждый месяц;",
                    "несколько получателей из числа руководства или сотрудников;",
                    "повторяющиеся назначения платежей;",
                    "отсутствие очевидной связи с хозяйственной деятельностью;",
                    "отсутствие понятного закрытия авансовыми отчетами;",
                    "выплаты на фоне ухудшения финансового состояния."
                ]
            },
            {
                "type": "h3",
                "text": "Почему это важно"
            },
            {
                "type": "paragraph",
                "text": "Крупные подотчетные суммы могут быть каналом вывода денежных средств, если по ним нет подтвержденных расходов, авансовых отчетов и экономического смысла."
            },
            {
                "type": "paragraph",
                "text": "Для проверки нужно смотреть, кому выдавались деньги, на какие цели, есть ли авансовые отчеты, какие первичные документы подтверждают расходы, возвращались ли неиспользованные суммы, были ли выплаты регулярными и связаны ли получатели с руководством или участниками."
            },
            {
                "type": "h3",
                "text": "Пример"
            },
            {
                "type": "paragraph",
                "text": "Каждый месяц должник перечисляет одному или нескольким сотрудникам по 2–3 млн рублей под отчет. При этом в выписке не видно регулярного возврата неиспользованных сумм, а назначение платежей остается общим: подотчет, хозяйственные расходы, на нужды организации."
            },
            {
                "type": "paragraph",
                "text": "Такая картина требует проверки авансовых отчетов и реальности расходов."
            },
            {
                "type": "h3",
                "text": "Как помогает ФинРадар"
            },
            {
                "type": "paragraph",
                "text": "В ФинРадаре можно отфильтровать операции по типам транзакций, искать платежи по назначениям, смотреть динамику подотчетных выплат, анализировать получателей, выделять повторяющиеся платежи и суммы, а также смотреть периоды, где такие операции резко выросли."
            },
            {
                "type": "image",
                "image": {
                    "src": "/assets/blog/7-anomaliy/podotchetnye-summy-anomalii.webp",
                    "alt": "ФинРадар показывает, сколько подотчетных средств ушло со счетов организации",
                    "caption": "Регулярные перечисления средств под отчет формируют направление для более детальной проверки такой деятельности должника. Есть ли авансовые отчеты, как использовались средства, был ли реальный экономический смысл у таких операций."
                }
            },
            {
                "type": "h2",
                "text": "7. Расходы корпоративной картой на ювелирные магазины, рестораны и поездки"
            },
            {
                "type": "paragraph",
                "text": "Самая наглядная аномалия – расходы, которые плохо похожи на обычные нужды бизнеса."
            },
            {
                "type": "list",
                "items": [
                    "покупки в ювелирных магазинах;",
                    "рестораны;",
                    "туристические поездки;",
                    "отели и авиабилеты для руководителя;",
                    "дорогостоящие личные расходы;",
                    "регулярные расходы по корпоративной карте без понятной деловой цели."
                ]
            },
            {
                "type": "h3",
                "text": "Почему это важно"
            },
            {
                "type": "paragraph",
                "text": "Корпоративная карта может использоваться для законных расходов. Но если деньги компании направляются на личное потребление руководителя или связанных лиц, это требует проверки."
            },
            {
                "type": "paragraph",
                "text": "Особенно в предбанкротный период, когда компания уже испытывала финансовые трудности или имела просроченные обязательства перед кредиторами."
            },
            {
                "type": "paragraph",
                "text": "Нужно выяснить, кто пользовался картой, как расходы связаны с деятельностью общества, есть ли первичные документы, были ли командировки, представительские расходы, договоры, утверждались ли лимиты и компенсировались ли личные расходы компании."
            },
            {
                "type": "h3",
                "text": "Пример"
            },
            {
                "type": "paragraph",
                "text": "В течение нескольких месяцев до банкротства по корпоративной карте проходят регулярные платежи в ресторанах, ювелирных магазинах и туристических сервисах. Назначения платежей и контрагенты не показывают явной связи с деятельностью должника."
            },
            {
                "type": "paragraph",
                "text": "Такие расходы могут стать основанием для дополнительной проверки: были ли они в интересах общества или фактически обслуживали личные потребности контролирующих лиц."
            },
            {
                "type": "h3",
                "text": "Как помогает ФинРадар"
            },
            {
                "type": "paragraph",
                "text": "В ФинРадаре такие операции можно искать через реестр платежей, фильтры по назначению платежа, фильтры по контрагентам, фильтры по типам операций, анализ нетипичных расходов и группировку операций по получателям."
            },
            {
                "type": "h2",
                "text": "Как искать такие аномалии в ФинРадаре"
            },
            {
                "type": "paragraph",
                "text": "Чтобы не просматривать тысячи строк вручную, проверку можно выстроить поэтапно."
            },
            {
                "type": "h3",
                "text": "1. Загрузить выписки в проект"
            },
            {
                "type": "paragraph",
                "text": "Сначала нужно собрать банковские выписки по анализируемому лицу: Excel, TXT / 1C Client-Bank, PDF или другие доступные форматы."
            },
            {
                "type": "h3",
                "text": "2. Проверить качество данных"
            },
            {
                "type": "paragraph",
                "text": "Перед анализом важно убедиться, что нет наложений периодов, дублей операций, пропущенных интервалов и проблемных файлов."
            },
            {
                "type": "image",
                "image": {
                    "src": "/assets/blog/10-minutes/kontrol-kachestva-bankovskih-vypisok.webp",
                    "alt": "Контроль качества банковских выписок с проверкой наложений, дублей и проблемных периодов",
                    "caption": "Перед анализом важно проверить наложения периодов, дубли и проблемные файлы."
                }
            },
            {
                "type": "h3",
                "text": "3. Посмотреть обороты по типам операций"
            },
            {
                "type": "paragraph",
                "text": "Этот раздел помогает увидеть, какие категории платежей формируют основной поток и где есть резкие всплески: зарплатные выплаты, займы, подотчетные средства, расходы физическим лицам, расчеты с поставщиками, операции с банками, ФССП и налогами."
            },
            {
                "type": "h3",
                "text": "4. Изучить обороты по контрагентам"
            },
            {
                "type": "paragraph",
                "text": "Раздел показывает, кто получил основную часть исходящих платежей, кто формирует поступления и насколько поток сконцентрирован на отдельных участниках."
            },
            {
                "type": "h3",
                "text": "5. Открыть раздел рисков"
            },
            {
                "type": "paragraph",
                "text": "Здесь можно увидеть контрагентов, которые требуют особого внимания: с риск-маркерами из ЕГРЮЛ, признаками банкротства, ликвидации, недостоверности сведений и другими факторами."
            },
            {
                "type": "h3",
                "text": "6. Перейти в отчет по конкретному контрагенту"
            },
            {
                "type": "paragraph",
                "text": "Если контрагент выглядит значимым или рискованным, можно посмотреть его отдельно: суммы, периоды, типы операций, встречные обороты и долю в потоке."
            },
            {
                "type": "h3",
                "text": "7. Использовать реестр платежей и фильтры"
            },
            {
                "type": "paragraph",
                "text": "Фильтры помогают быстро сузить массив операций по периоду, сумме, контрагенту, типу операции, назначению платежа, конкретной выписке и направлению платежа."
            },
            {
                "type": "paragraph",
                "text": "Такой подход помогает перейти от общего массива операций к конкретным платежам, которые нужно проверять глубже."
            },
            {
                "type": "cta",
                "title": "Хотите проверить такие аномалии в своей выписке?",
                "text": "Загрузите банковскую выписку в ФинРадар и посмотрите контрагентов, обороты, риск-маркеры, фильтры и операции, которые требуют внимания."
            },
            {
                "type": "signup"
            },
            {
                "type": "h2",
                "text": "Что важно помнить при анализе аномалий"
            },
            {
                "type": "paragraph",
                "text": "Аномалия – это не готовый вывод. Это повод задать правильные вопросы."
            },
            {
                "type": "list",
                "items": [
                    "дату платежа;",
                    "период относительно банкротства;",
                    "финансовое состояние должника;",
                    "связь получателя с должником;",
                    "экономический смысл сделки;",
                    "договорную базу;",
                    "первичные документы;",
                    "встречное исполнение;",
                    "реальность поставки, работ или услуг;",
                    "добросовестность контрагента."
                ]
            },
            {
                "type": "paragraph",
                "text": "ФинРадар помогает быстрее найти и структурировать сигналы, но итоговая правовая оценка всегда требует анализа документов и обстоятельств конкретного дела."
            },
            {
                "type": "h2",
                "text": "Итог"
            },
            {
                "type": "paragraph",
                "text": "В банковской выписке должника-юридического лица можно быстро увидеть операции и контрагентов, которые требуют особого внимания."
            },
            {
                "type": "paragraph",
                "text": "В первую очередь стоит проверить платежи контрагентам с недостоверными сведениями в ЕГРЮЛ, концентрацию исходящих платежей на нескольких слабых контрагентах, встречные расчеты с внешне независимыми участниками, погашение займов физическим лицам незадолго до банкротства, резкий рост выплат руководителю и топ-менеджерам, регулярные выдачи крупных подотчетных сумм и расходы корпоративной картой на личное потребление."
            },
            {
                "type": "paragraph",
                "text": "Такие признаки не доказывают нарушение автоматически, но помогают понять, где может быть скрыт вывод активов, предпочтительное удовлетворение отдельных лиц или экономически необоснованные платежи."
            },
            {
                "type": "cta",
                "title": "Попробуйте ФинРадар бесплатно 7 дней",
                "text": "Загрузите банковскую выписку и посмотрите, какие аномалии, контрагенты, обороты и риск-сигналы можно увидеть в вашем проекте."
            },
            {
                "type": "faq",
                "items": [
                    {
                        "question": "Аномалия в банковской выписке юридического лица доказывает нарушение?",
                        "answer": "Нет. Аномалия – это сигнал для проверки. Нужно анализировать документы, период операции, связь сторон, экономический смысл платежа и финансовое состояние должника."
                    },
                    {
                        "question": "Почему статья отдельно говорит о юридических лицах?",
                        "answer": "У юридических лиц и физических лиц разные структуры рисков. Для юрлиц важны контрагенты, хозяйственные операции, займы, зарплатные выплаты, подотчетные суммы и движение денег между организациями. Выписки физических лиц требуют отдельной методики."
                    },
                    {
                        "question": "Какие контрагенты требуют внимания в первую очередь?",
                        "answer": "В первую очередь стоит смотреть контрагентов с недостоверными сведениями в ЕГРЮЛ, признаками ликвидации или банкротства, низкой численностью, сомнительной деловой репутацией и высокой долей в исходящих платежах должника."
                    },
                    {
                        "question": "Почему резкий рост зарплат перед банкротством может быть аномалией?",
                        "answer": "Зарплата сама по себе является обычной хозяйственной операцией. Но если выплаты руководителю, учредителю или топ-менеджерам резко растут незадолго до банкротства, особенно без сопоставимого роста НДФЛ и страховых взносов, это требует дополнительной проверки."
                    },
                    {
                        "question": "Как ФинРадар помогает искать такие операции?",
                        "answer": "ФинРадар помогает загрузить выписки, проверить качество данных, увидеть обороты по типам операций и контрагентам, открыть риск-маркеры, перейти в отчет по контрагенту и отфильтровать платежи по периоду, сумме, назначению и типу операции."
                    }
                ]
            }
        ]
    }
];

export const blogPostBySlug = blogPosts.reduce((acc, post) => {
    acc[post.slug] = post;
    return acc;
}, {});

export function getBlogPostUrl(post) {
    return `${BLOG_BASE_URL}/blog/${post.slug}/`;
}

export function getBlogPostStructuredData(post) {
    const canonicalUrl = getBlogPostUrl(post);
    const faqBlock = post.content.find((block) => block.type === 'faq');

    return {
        '@context': 'https://schema.org',
        '@graph': [
            {
                '@type': 'BlogPosting',
                '@id': `${canonicalUrl}#article`,
                headline: post.title,
                description: post.description,
                datePublished: post.datePublished,
                dateModified: post.dateModified || post.datePublished,
                inLanguage: 'ru-RU',
                url: canonicalUrl,
                mainEntityOfPage: {
                    '@type': 'WebPage',
                    '@id': canonicalUrl,
                },
                image: {
                    '@type': 'ImageObject',
                    url: `${BLOG_BASE_URL}${post.heroImage.src}`,
                },
                author: {
                    '@type': 'Organization',
                    name: 'ФинРадар',
                    url: `${BLOG_BASE_URL}/`,
                },
                publisher: {
                    '@type': 'Organization',
                    name: 'ФинРадар',
                    url: `${BLOG_BASE_URL}/`,
                    logo: {
                        '@type': 'ImageObject',
                        url: `${BLOG_BASE_URL}/favicon-192x192.png`,
                    },
                },
                articleSection: post.articleSection || post.category,
                keywords: post.keywords,
            },
            {
                '@type': 'BreadcrumbList',
                '@id': `${canonicalUrl}#breadcrumbs`,
                itemListElement: [
                    {
                        '@type': 'ListItem',
                        position: 1,
                        name: 'ФинРадар',
                        item: `${BLOG_BASE_URL}/`,
                    },
                    {
                        '@type': 'ListItem',
                        position: 2,
                        name: 'Блог',
                        item: `${BLOG_BASE_URL}/blog/`,
                    },
                    {
                        '@type': 'ListItem',
                        position: 3,
                        name: post.title,
                        item: canonicalUrl,
                    },
                ],
            },
            ...(faqBlock ? [{
                '@type': 'FAQPage',
                '@id': `${canonicalUrl}#faq`,
                mainEntity: faqBlock.items.map((item) => ({
                    '@type': 'Question',
                    name: item.question,
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: item.answer,
                    },
                })),
            }] : []),
        ],
    };
}
